export const emailNotificationCodeList = ['fp'];
